var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Filial',{attrs:{"data-cy":"search-filter-filial-social-panel","filterName":_vm.filter.title,"selectedInputRangeValues":_vm.selectedInputRangeValues,"selected":_vm.selected},on:{"setInputsRange":_vm.setInputsRangeFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }